module.exports = __webpack_public_path__ + "img/个人3@2x.1973a113.png";